export default __webpack_public_path__ + "static/media/GrayScrum.9e7e8db8.png";